import React from "react";
import { List, Input, Button, Spin, Typography, Space, Avatar, message } from 'antd';
import { SearchOutlined, ShoppingCartOutlined, LoadingOutlined } from '@ant-design/icons';
import ItemImage from '../../components/Item/ItemImage';
import "./ItemsTableList.css";
import MobileCartSelect from "../CartSelect/MobileCartSelect";
import MobileFavoriteCartSelect from "../CartSelect/MobileFavoriteCartSelect";
import firebase from "../../firebase";
// import { toast } from 'react-toastify';

const { Text } = Typography;

class MobileItems extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            dbItems: [],
            targetOrgSellerRef: null,
            organization: {},
            collapsed: false,
            last: null,
            itemsPerPage: 12,
            changed: false,
            searchwordA: '',
            cartselect: false,
            otasukeCartSelect: false,
            favoriteCartSelect: false,
            selectedItem: {},
            loadedAllItem: false,
            cn: null,
            notMore: false,
            modalType: 'standard'
        }
    }





    getItems = (reset = false, searchWord = '') => {
        if (!this._isMounted) return;

        const { db, org, userOrg, user } = this.props;
        if (!db || !org || !org.id) {
            // Not enough info to fetch yet or no organization selected
            if (this._isMounted && this.state.loading) {
                this.setState({ loading: false });
            }
            return;
        }

        if (this.state.loading && !reset) return;

        const userOrgId = (userOrg && userOrg.id) || (user && user.organization);

        this.setState({ loading: true });

        let searchWords = [];
        if (searchWord) {
            let word = searchWord.toUpperCase().replace(/[\!-\~]/g, function (s) {
                return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
            });
            let words = word.split(/\s+/);
            for (var i = 0; i < words.length; i++) {
                for (var j = 0; j < words[i].length - 1; j++) {
                    searchWords.push(words[i][j] + words[i][j + 1]);
                }
            }
        }

        let query;
        if (org.reseller && userOrgId && ((userOrg && userOrg.maker) || (user && user.maker))) {
            // メーカー: items_stock/{makerOrg}/buyers/{resellerOrg}/items
            query = db.collection('items_stock').doc(userOrgId).collection('buyers').doc(org.id).collection('items');
        } else if (org.maker && userOrgId && ((userOrg && userOrg.reseller) || (user && user.reseller))) {
            // 販社・仕入モード: items_stock/{makerOrg}/buyers/{resellerOrg}/items
            query = db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrgId).collection('items').where('archive', '==', false);
        } else if (org.reseller && userOrgId && ((userOrg && userOrg.buyer) || (user && user.buyer))) {
            // 購入ユーザー: items_sell/{resellerOrg}/buyers/{buyerOrg}/items
            query = db.collection('items_sell').doc(org.id).collection('buyers').doc(userOrgId).collection('items').where('archive', '==', false);
        } else if (org.buyer && userOrgId && ((userOrg && userOrg.reseller) || (user && user.reseller))) {
            // 販社・販売モード: items_sell/{resellerOrg}/buyers/{buyerOrg}/items
            query = db.collection('items_sell').doc(userOrgId).collection('buyers').doc(org.id).collection('items');
        } else if (user && user.admin) {
            query = db.collection('items_sell').doc(org.id).collection('items');
        }

        if (!query) {
            console.log('MobileItems: No query generated for current user/org state');
            if (this._isMounted) this.setState({ loading: false });
            return;
        }

        if (searchWords.length > 0) {
            searchWords.forEach(word => {
                query = query.where(`tokenMap.${word}`, '==', true);
            });
        }

        if (this.state.cn) {
            query = query.where('cn', '==', this.state.cn);
        }

        if (!searchWord && !this.state.cn) {
            query = query.orderBy('P4CLOUD商品名ふりがな', 'asc');
        }

        query = query.limit(this.state.itemsPerPage);

        if (this.state.last && !reset) {
            query = query.startAfter(this.state.last);
        }

        query.get().then((snapshot) => {
            if (!this._isMounted) return;

            const newItems = snapshot.docs.map(doc => {
                let data = doc.data();
                data.id = doc.id;
                return data;
            });

            this.setState({
                dbItems: reset ? newItems : [...this.state.dbItems, ...newItems],
                last: snapshot.docs[snapshot.docs.length - 1] || null,
                loading: false,
                loadedAllItem: snapshot.docs.length < this.state.itemsPerPage,
                loaded: true
            }, () => {
                console.log('MobileItems: Successfully fetched ' + newItems.length + ' items');
            });
        }).catch(err => {
            console.error("MobileItems: Error fetching items:", err);
            if (this._isMounted) this.setState({ loading: false });
        });
    }


    componentDidMount() {
        this._isMounted = true;
        let cn = new URLSearchParams(this.props.search).get("cn");
        this.setState({
            cn: cn,
        })
        this.getItems();
        window.addEventListener('scroll', event => this.watchCurrentPosition(), true);
    }

    componentDidUpdate(prevProps) {
        const orgId = this.props.org && this.props.org.id;
        const prevOrgId = prevProps.org && prevProps.org.id;
        const userOrgId = this.props.userOrg && this.props.userOrg.id;
        const prevUserOrgId = prevProps.userOrg && prevProps.userOrg.id;

        if (orgId !== prevOrgId || userOrgId !== prevUserOrgId) {
            if (orgId && (userOrgId || (this.props.user && this.props.user.admin))) {
                this.setState({
                    changed: false,
                    loadedAllItem: false,
                    dbItems: [],
                    loading: true,
                    loaded: false
                }, () => {
                    this.getItems(true);
                });
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('scroll', event => this.watchCurrentPosition(), true);
    }

    watchCurrentPosition() {
        if (window.innerHeight + this.scrollTop() + 50 >= document.body.clientHeight) {
            // console.log('reach end', window.innerHeight, this.scrollTop(), document.body.clientHeight);
            this.onReachEnd();
        }
    }

    scrollTop() {
        return Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
        );
    }

    onReachEnd = () => {
        if (!this.state.loading && !this.state.loadedAllItem && !this.state.notMore) {
            this.getItems(false, this.state.searchwordA);
        }
    }

    addCart = (item) => {
        this.setState({
            selectedItem: item,
            cartselect: true,
            modalType: 'standard'
        });
    }

    addFavoriteCart = (item) => {
        let self = this;

        if (this.state.cn === null || this.state.cn === '') {
            this.setState({
                selectedItem: item,
                favoriteCartSelect: true
            });
        } else {
            let cartId = this.state.cn;
            this.props.db.collection('favorite_set').doc(this.props.user.id)
                .collection('favorite_set').doc(this.props.org.id)
                .get()
                .then((doc) => {
                    if (doc.exists) {
                        let carts = doc.data() || {};
                        if (!carts[cartId]) {
                            carts[cartId] = { items: [] };
                        }
                        let cart = carts[cartId].items || [];
                        let date = firebase.firestore.Timestamp.fromDate(new Date());

                        const itemsToAdd = Array.isArray(item) ? item : [item];
                        itemsToAdd.forEach(v => {
                            const itemName = v['P4CLOUD商品名'] || '';
                            const existing = cart.find(it => it.name === itemName);
                            if (!existing) {
                                cart.push({
                                    name: itemName,
                                    maker: v['正式メーカー名'] || '',
                                    code: v['販売企業商品コード'] || '',
                                    sellercode: v['仕入先事業所コード'] || '',
                                    sellername: v['仕入先事業所名'] || '',
                                    makeredicode: v['仕入先EDIコード商品コード'] || '',
                                    makerordercode: v['仕入先発注コード'] || '',
                                    price: v['price'] && v['price'][0] && v['price'][0]['price'] ? v['price'][0]['price'] : 0,
                                    tax: v['消費税率'] ? v['消費税率'] : 0,
                                    id: v.id || v.objectID,
                                    count: 1,
                                    update: date,
                                });
                            } else {
                                existing.count += 1;
                                existing.update = date;
                            }
                        });

                        carts[cartId].items = cart;
                        carts[cartId].rejected = false;
                        carts[cartId].created = carts[cartId].created || date;
                        carts[cartId].latestUpdate = date;

                        if (!carts[cartId].creatorUser) {
                            carts[cartId].creatorUser = this.props.user.id;
                            carts[cartId].creatorUserName = this.props.user.last_name + " " + this.props.user.first_name;
                        }

                        let cartMainRef = this.props.db.collection('favorite_set').doc(this.props.user.id);
                        let cartRef = cartMainRef.collection('favorite_set').doc(this.props.org.id);

                        cartMainRef.set({ dummy: 'test' }, { merge: true });
                        cartRef.set({
                            [cartId]: carts[cartId],
                            update: date,
                        }, { merge: true })
                            .then(() => {
                                message.success("お気に入りへの追加が完了しました。");
                                self.props.cProps.history.push('/favorite/cart/' + (self.state.cn * 1 + 1))
                            })
                            .catch(error => console.error("Error setting document: ", error));
                    }
                });
        }
    }

    addOtasukeCart = (item) => {
        if (this.state.cn === null || this.state.cn === '') {
            this.setState({
                selectedItem: item,
                otasukeCartSelect: true,
                modalType: 'otasuke'
            });
        } else {
            let cartId = this.state.cn;
            let self = this;
            this.props.db.collection('otasuke_carts').doc(this.props.user.id)
                .collection('otasuke_carts').doc(this.props.org.id)
                .get()
                .then((doc) => {
                    if (doc.exists) {
                        let carts = doc.data();
                        if (!carts[cartId]) {
                            carts[cartId] = { items: [] };
                        }
                        let cart = carts[cartId].items || [];
                        let date = firebase.firestore.Timestamp.fromDate(new Date());

                        const itemsToAdd = Array.isArray(item) ? item : [item];
                        itemsToAdd.forEach(v => {
                            const itemName = v['P4CLOUD商品名'] || '';
                            const existing = cart.find(it => it.name === itemName);
                            if (!existing) {
                                cart.push({
                                    name: itemName,
                                    maker: v['正式メーカー名'] || '',
                                    code: v['販売企業商品コード'] || '',
                                    sellercode: v['仕入先事業所コード'] || '',
                                    sellername: v['仕入先事業所名'] || '',
                                    makeredicode: v['仕入先EDIコード商品コード'] || '',
                                    makerordercode: v['仕入先発注コード'] || '',
                                    price: v['price'] && v['price'][0] && v['price'][0]['price'] ? v['price'][0]['price'] : 0,
                                    tax: v['消費税率'] ? v['消費税率'] : 0,
                                    id: v.id || v.objectID,
                                    count: 1,
                                    update: date,
                                });
                            } else {
                                existing.count += 1;
                                existing.update = date;
                            }
                        });

                        carts[cartId].items = cart;
                        carts[cartId].rejected = false;
                        carts[cartId].created = carts[cartId].created || date;
                        carts[cartId].latestUpdate = date;

                        if (!carts[cartId].creatorUser) {
                            carts[cartId].creatorUser = this.props.user.id;
                            carts[cartId].creatorUserName = this.props.user.last_name + " " + this.props.user.first_name;
                        }

                        let cartMainRef = this.props.db.collection('otasuke_carts').doc(this.props.user.id);
                        let cartRef = cartMainRef.collection('otasuke_carts').doc(this.props.org.id);

                        cartMainRef.set({ dummy: 'test' }, { merge: true });
                        cartRef.set({
                            [cartId]: carts[cartId],
                            update: date,
                        }, { merge: true })
                            .then(() => {
                                self.props.cProps.history.push('/otasuke/cart/' + (self.state.cn * 1 + 1));
                            })
                            .catch(error => console.error("Error setting document: ", error));
                    }
                });
        }
    }

    filter = () => {
        this.setState({
            dbItems: [],
            last: null,
            loadedAllItem: false,
            notMore: false,
            loading: true
        }, () => {
            this.getItems(true, this.state.searchwordA);
        });
    }

    render() {
        if (!this.props.org) return <></>;

        let isBuyer = false;
        if (this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.reseller) {
            isBuyer = true;
        } else if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.buyer) {
            isBuyer = true;
        }

        const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

        return (
            <div className="mobile-items-container" style={{ paddingBottom: '50px', background: '#f5f5f5', minHeight: '100vh' }}>
                <div style={{ position: 'sticky', top: 64, zIndex: 10, background: '#fff', padding: '10px 15px', borderBottom: '1px solid #f0f0f0' }}>
                    <Input
                        placeholder="商品を検索"
                        prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                        value={this.state.searchwordA}
                        onChange={(e) => this.setState({ searchwordA: e.target.value })}
                        onPressEnter={() => this.filter()}
                        size="large"
                        allowClear
                        style={{ borderRadius: '8px' }}
                    />
                </div>

                <div style={{ padding: '16px' }}>
                    <List
                        itemLayout="horizontal"
                        dataSource={this.state.dbItems}
                        loading={this.state.loading && this.state.dbItems.length === 0}
                        locale={{ emptyText: '該当する商品が見つかりませんでした' }}
                        renderItem={(item) => {
                            let disableButton = false;
                            let priceText = '';
                            let orderButtonText = 'カート';

                            if (!item['price'] || (item['price'][0] && !item['price'][0]['price'])) {
                                disableButton = true;
                                priceText = '要見積';
                            } else if (item['price'] && item['price'][0] && !item['price'][0]['expiration_date']) {
                                disableButton = true;
                                priceText = '要見積';
                            } else if (item['price'] && item['price'][0] && item['price'][0]['expiration_date']) {
                                let expiration_date = item['price'][0]['expiration_date'];
                                let expDate;
                                try {
                                    expDate = expiration_date.toDate();
                                } catch (e) {
                                    expDate = new Date(expiration_date._seconds * 1000 + expiration_date._nanoseconds / 1000000);
                                }

                                if (expDate && ((expDate.getTime() - this.props.dateNow) < 0)) {
                                    disableButton = true;
                                    orderButtonText = '期限切れ';
                                    priceText = '期限切れ要見積';
                                }
                            }

                            if (!priceText && item['price'] && item['price'][0] && item['price'][0]['price']) {
                                priceText = Number(item['price'][0]['price']).toLocaleString() + '円';
                            }

                            return (
                                <List.Item
                                    onClick={() => this.props.cProps.history.push('/items/' + (item.id || item.objectID))}
                                    style={{
                                        padding: '16px',
                                        marginBottom: '16px',
                                        background: '#fff',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                        border: 'none',
                                        display: 'block'
                                    }}
                                >
                                    <List.Item.Meta
                                        avatar={
                                            <div style={{ width: 60, height: 60, overflow: 'hidden', borderRadius: '4px', border: '1px solid #f0f0f0' }}>
                                                {item.image ? (
                                                    <ItemImage src={item.image} storage={this.props.storage} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                ) : item['files'] && item['files'][0] ? (
                                                    <ItemImage src={item['files'][0]['file']} storage={this.props.storage} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                ) : (
                                                    <div style={{ width: '100%', height: '100%', background: '#fafafa', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bfbfbf' }}>
                                                        <ShoppingCartOutlined style={{ fontSize: '24px' }} />
                                                    </div>
                                                )}
                                            </div>
                                        }
                                        title={
                                            <Text strong style={{ fontSize: '1rem', lineHeight: '1.2', display: 'block', marginBottom: '4px' }}>
                                                {item['P4CLOUD商品名']}
                                            </Text>
                                        }
                                        description={
                                            <Space direction="vertical" size={0}>
                                                <Text type="secondary" style={{ fontSize: '0.8rem' }}>
                                                    {item['正式メーカー名']}
                                                </Text>
                                                <Text strong style={{ color: '#d32f2f', fontSize: '1rem' }}>
                                                    {priceText}
                                                </Text>
                                            </Space>
                                        }
                                    />
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignItems: 'center',
                                        borderTop: '1px solid #f0f0f0',
                                        paddingTop: '12px',
                                        marginTop: '12px',
                                        gap: '8px'
                                    }}>
                                        <Button
                                            size="middle"
                                            disabled={disableButton}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.addFavoriteCart(item);
                                            }}
                                            style={{
                                                borderRadius: '6px',
                                                fontSize: '0.85rem'
                                            }}
                                        >
                                            お気に入りセット登録
                                        </Button>
                                        {isBuyer ? (
                                            <Button
                                                type="primary"
                                                size="middle"
                                                disabled={disableButton}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.addCart(item);
                                                }}
                                                style={{
                                                    borderRadius: '6px',
                                                    minWidth: '80px',
                                                    fontSize: '0.85rem'
                                                }}
                                            >
                                                {orderButtonText}
                                            </Button>
                                        ) : (
                                            <Button
                                                type="primary"
                                                size="middle"
                                                disabled={disableButton}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.addOtasukeCart(item);
                                                }}
                                                style={{
                                                    borderRadius: '6px',
                                                    minWidth: '80px',
                                                    fontSize: '0.85rem'
                                                }}
                                            >
                                                お助けカートに入れる
                                            </Button>
                                        )}
                                    </div>
                                </List.Item>
                            );
                        }}
                        loadMore={
                            this.state.loading && this.state.dbItems.length > 0 ? (
                                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                                    <Spin indicator={antIcon} />
                                </div>
                            ) : null
                        }
                    />
                </div>

                {(this.state.cartselect || this.state.otasukeCartSelect) && (
                    <MobileCartSelect
                        isOpen={this.state.cartselect || this.state.otasukeCartSelect}
                        onClose={(added) => {
                            this.setState({
                                cartselect: false,
                                otasukeCartSelect: false
                            });
                            if (added === true) {
                                message.success("カートに追加しました");
                            }
                        }}
                        type={this.state.modalType}
                        data={this.state.selectedItem}
                        db={this.props.db}
                        user={this.props.user}
                        org={this.props.org}
                        userOrg={this.props.userOrg}
                        dateNow={this.props.dateNow}
                    />
                )}

                {this.state.favoriteCartSelect && (
                    <MobileFavoriteCartSelect
                        isOpen={this.state.favoriteCartSelect}
                        onClose={(added) => {
                            this.setState({ favoriteCartSelect: false });
                            if (added === true) {
                                message.success("お気に入りへの追加が完了しました。");
                            }
                        }}
                        data={this.state.selectedItem}
                        db={this.props.db}
                        user={this.props.user}
                        org={this.props.org}
                        userOrg={this.props.userOrg}
                        dateNow={this.props.dateNow}
                    />
                )}
            </div>
        );
    }
}

export default MobileItems;
